// extracted by mini-css-extract-plugin
export default {"container":"style_container__5MsDi","innerBox":"style_innerBox__ED0sD"};